<template>
  <div 
    :class="offsetTop >= windowHeight ? 'navbar-background':''"
    id="nav">
    <router-link 
      to="/home">
      <img 
        class="navbar-logotype"
        src="/img/static/logotype.png" 
        alt="company logotype">
    </router-link>
    <!-- Start navbar -->
    <router-link 
      :style="offsetTop >= windowHeight ? 'color: black !important' :''"
      active-class="navbar-item-active"
      class="navbar-item"
      to="/home">
      Home
    </router-link> 
    <router-link 
      :style="offsetTop >= windowHeight ? 'color: black !important' :''"
      active-class="navbar-item-active"
      class="navbar-item"
      to="/services">
      Tratamientos
    </router-link>
    <router-link 
      :style="offsetTop >= windowHeight ? 'color: black !important' :''"
      active-class="navbar-item-active"
      class="navbar-item"
      to="/contact">
      Contacto
    </router-link>
    <!-- End navbar -->
    <v-spacer></v-spacer>
    <!-- start icons --> 
    <a
      target="_blank"
      class="fb navbar-social-media"
      href="https://www.facebook.com">
      <v-icon
        color="#4E66FF">
        mdi-facebook
      </v-icon>
    </a>
    <a
      target="_blank"
      class="ig navbar-social-media"
      href="https://www.instagram.com">
      <v-icon
        color="#4E66FF">
        mdi-instagram
      </v-icon>
    </a>
    <!-- end icons --> 
    <!-- start reserve button -->
    <v-btn
      @click="setReserve"
      class="navbar-reserve-button"
      color="#4E66FF">
      <p
        class="navbar-reserve-button-text">
        Haz tu Cita
      </p>
    </v-btn>
    <!-- end reserve button -->
    <!-- Start mobile option -->
    <div 
      class="mobile-navbar-activator">
      <v-btn
        @click="toggleMenu"
        class="dropbtn mobile-nav-activator-menu"
        color="#4E66FF"
        dark
        icon
        small
        fab>
        <v-icon>
          mdi-menu
        </v-icon>
      </v-btn>
    </div>
    <div
      class="mobile-nav-div"
      id="mobile-navigation-menu">
      <v-layout
        :style="'padding: 30px 35px 30px 35px; position: absolute; right: 10px; z-index: 10'"
        row>
        <v-btn
          style="z-index: 10"
          color="#4E66FF"
          @click="toggleMenu"
          fab
          small>
          <v-icon
            style="color: white">
            mdi-close
          </v-icon>
        </v-btn>
      </v-layout>
      <v-layout
        column>
        <v-card
          @click="goTo('/home')"
          :style="$route.fullPath !== '/home' ? '':'pointer-events: none; background-color: #306BE6 !important'"
          class="navbar-options"
          tile
          flat>
          <p
            :style="$route.fullPath !== '/home' ? '':'color: white'"
            class="mobile-navbar-option">
            Home
          </p>
        </v-card>
        <v-card
          @click="goTo('/services')"
          :style="$route.fullPath !== '/services' ? '':'pointer-events: none; background-color: #306BE6 !important'"
          class="navbar-options"
          tile
          flat>
          <p
            :style="$route.fullPath !== '/services' ? '':'color: white'"
            class="mobile-navbar-option">
            Tratamientos
          </p>
        </v-card>
        <v-card
          @click="goTo('/contact')"
          :style="$route.fullPath !== '/contact' ? '':'pointer-events: none; background-color: #306BE6 !important'"
          class="navbar-options"
          tile
          flat>
          <p
            :style="$route.fullPath !== '/contact' ? '':'color: white'"
            class="mobile-navbar-option">
            Contacto
          </p>
        </v-card>
      </v-layout>
    </div>
    <!-- End mobile option -->
  </div>
</template>
<script>
  export default {
    data: () => ({
      bMobileNavMenu: false
    }),
    computed: {
      offsetTop () {
        return this.$store.state.offsetTop
      },
      windowHeight () {
        return window.innerHeight
      }
    },
    methods: {
      goTo (path) {
        this.$router.push(path)
        this.toggleMenu()
      },
      toggleMenu () {
        var myMobileMenu = document.getElementById('mobile-navigation-menu')
        if (this.bMobileNavMenu) {
          myMobileMenu.style = 'width: 0vw'
        } else {
          myMobileMenu.style = 'width: 100vw'
        }
        this.bMobileNavMenu = !this.bMobileNavMenu
      },
      setReserve () {
        // redirct to contact form
        this.$router.push('/contact')
        const self = this
        setTimeout(
          function() {
            var options = {
              duration: 1000,
              offset: -50
            }
            self.$vuetify.goTo('#form', options)
          }
        , 500);
        // for future use
        // this.$store.commit('setReservation', true)
      }
    }
  }
</script>
<style
  scoped>
  .mobile-navbar-option {
    position: absolute;
    top: 50%;
    left: 10%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-family: 'Raleway', sans-serif;
    font-size: 40px;
  }
  .blue-background {
    background-color: #306BE6;
  }
  .navbar-options {
    border-bottom-style: solid;
    border-bottom-color: black;
    border-bottom-width: 1px;
    border-radius: 0px !important;
    width: 100%; 
    min-height: 33.33vh; 
  }
  .mobile-nav-div {
    overflow: hidden;
    left: 0;
    top: 0;
    width: 0px;
    height: 100vh;
    background-color: white;
    position: fixed;
    z-index: 100;
    transition: width .25s ease-in;
  }
  @media screen and (max-width: 625px) {
    .navbar-item {
      display: none;
    }
    .mobile-nav-activator {
      display: flex !important;
    }
    .mobile-nav-activator-menu {
      display: flex !important;
    }
    .ig {
      background-color: rgba(255, 255, 255, 0.457);
      border-radius: 10px;
      padding: 3px;
    /*  position: fixed;
      bottom: 10px; 
      right: 0 */
    }
    .fb {
      background-color: rgba(255, 255, 255, 0.457);
      border-radius: 10px;
      padding: 3px;
      /* position: fixed;
      bottom: 50px; 
      right: 0 */
    }
    .navbar-reserve-button {
      display: none;
    }
  }

  .navbar-item-active {
    text-decoration: underline !important;
  }

  .navbar-background {
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  }

  @media screen and (min-width: 625px) {
    .mobile-navbar-activator {
      display: none !important
    }
    .mobile-nav-div {
      display: none !important
    }
  }

  
  .mobile-nav-activator-menu {
    margin-left: 5px;
    margin-top: -9px;
    align-self: center;
    display: none;
  }

  .navbar-item-mobile {
    transition: color 900ms linear;
    margin-right: 9px;
    margin-left: 9px;
    align-self: center;
    font-size: 50px;
  }

  .navbar-item-active-mobile {
    text-decoration: underline !important;
  }

  .navbar-item {
    transition: color 900ms linear;
    margin-right: 9px;
    margin-left: 9px;
    align-self: center;
  }

  .navbar-reserve-button {
    align-self: center;
  }

  .navbar-social-media {
    margin-right: 14px;
    align-self: center;
    text-decoration: none;
    text-transform: none;
  }

  .navbar-logotype {
    margin-top: -10px;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    align-self: center;
  }

  .navbar-reserve-button-text {
    color: white;
    text-transform: none !important;
    font-weight: bold;
  }

  #nav {
    transition: background-color 300ms linear;
    width: 100%;
    top: 0;
    z-index: 3;
    position: fixed;
    max-height: 80px;
    display: flex;
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    text-decoration: none;
    text-transform: none;
    color: #ffffff;
  }
  
  #nav a.router-link-exact-active {
    color: #5866c6;
  }
</style>